import clsx from 'clsx'

import BodyText from '../BodyText'

import styles from './MiddotSeparator.module.scss'

type MiddotSeparatorProps = {
  className?: string
} & (
  | {
      visibleMobile: boolean
      hiddenMobile?: never
    }
  | {
      visibleMobile?: never
      hiddenMobile: boolean
    }
  | {
      visibleMobile?: never
      hiddenMobile?: never
    }
)

function MiddotSeparator({
  className,
  visibleMobile,
  hiddenMobile,
}: MiddotSeparatorProps) {
  return (
    <BodyText
      className={clsx(styles.separator, className, {
        [styles.visibleMobile]: visibleMobile,
        [styles.hiddenMobile]: hiddenMobile,
      })}
    >
      &middot;
    </BodyText>
  )
}

export default MiddotSeparator
